import React from "react";

/**
 * data: [{ type, pct, color }]
 */
export default function Donut({ data = [] }) {
  const total = data.reduce((s, d) => s + d.pct, 0) || 1;
  let cum = 0;
  const cx = 60, cy = 60, r = 48, inner = 30;

  const slices = data.map((d) => {
    const start = cum;
    cum += d.pct;
    const a1 = (start / total) * Math.PI * 2 - Math.PI / 2;
    const a2 = (cum  / total) * Math.PI * 2 - Math.PI / 2;

    const lx = cx + Math.cos(a1) * r,   ly = cy + Math.sin(a1) * r;
    const ex = cx + Math.cos(a2) * r,   ey = cy + Math.sin(a2) * r;
    const ix1= cx + Math.cos(a1)*inner, iy1= cy + Math.sin(a1)*inner;
    const ix2= cx + Math.cos(a2)*inner, iy2= cy + Math.sin(a2)*inner;
    const large = d.pct / total > 0.5 ? 1 : 0;

    const path = `M${lx},${ly} A${r},${r},0,${large},1,${ex},${ey} L${ix2},${iy2} A${inner},${inner},0,${large},0,${ix1},${iy1} Z`;
    return { ...d, path };
  });

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
      <svg width={120} height={120} viewBox="0 0 120 120">
        {slices.map((s, i) => (
          <path key={i} d={s.path} fill={s.color} opacity={0.9} />
        ))}
      </svg>
      <div>
        {data.map((d, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6, fontSize: 13 }}>
            <div style={{ width: 10, height: 10, borderRadius: 2, background: d.color, flexShrink: 0 }} />
            <span style={{ color: "var(--color-text-primary)" }}>{d.type}</span>
            <span style={{ color: "var(--color-text-secondary)", marginLeft: "auto", paddingLeft: 12 }}>{d.pct}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}